import { useMutation } from "react-query";
import { addOfficeHierarchy } from "../../../../actions/OfficeHierarchy";

const useAddOfficeHierarchy = () => {
  return useMutation(addOfficeHierarchy);
};
export default useAddOfficeHierarchy;
